export const getPaymentMethod = (paymentMethod: string) => {
  if (
    paymentMethod === "bankSlip" ||
    paymentMethod === "bank_slip" ||
    paymentMethod === "boleto"
  )
    return "bank-slip";
  if (paymentMethod === "creditCard" || paymentMethod === "credit_card")
    return "credit-card";
  if (paymentMethod === "pix") return "pix";

  return "credit-card";
};
